// initial state
import axios from "axios";

const state = () => ({
    all: []
})

// getters
const getters = {}

// actions
const actions = {
    async getAll ({ commit }) {
        axios.get(route('frontend.project.list')).then(result => {
            commit('setProjects', result.data)
        });
    }
}

// mutations
const mutations = {
    setProjects (state, projects) {
        state.all = projects
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
